import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './EmbedPlaceholder.css';
import TooltipOnHover from '../../../components/TooltipOnHover';
import Button from '../../../components/Button';
import getBlockClassName from '../../utils/getBlockClassName';
import getBlockId from '../../../utils/getBlockId';
import { getEmbedInformationsList, getEmbedInformation } from '../config';
import EmbeddableTypes from '../../../types/EmbeddableTypes';
import setEmbedType from '../utils/setEmbedType';

var EmbedPlaceholder =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmbedPlaceholder, _React$Component);

  function EmbedPlaceholder() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EmbedPlaceholder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EmbedPlaceholder)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClickEmbeddableType", function (event, embedType) {
      event.preventDefault();
      setEmbedType(_this.props.editor, _this.props.node, embedType);
    });

    return _this;
  }

  _createClass(EmbedPlaceholder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          pluginStore = _this$props.pluginStore,
          node = _this$props.node;
      pluginStore.updateItem(node.key, {
        onSubmit: function onSubmit() {
          return _this2.props.onSubmit(_this2.props.node.text, _this2.props.extractorsSelectorFilter);
        }
      });
    }
  }, {
    key: "renderEmbeddablesTypes",
    value: function renderEmbeddablesTypes() {
      var _this3 = this;

      return React.createElement("div", {
        className: "flexbox flexbox-align-center",
        style: {
          right: 0,
          top: 0,
          bottom: 0
        }
      }, getEmbedInformationsList().filter(function (_ref) {
        var promoted = _ref.promoted;
        return promoted === true;
      }).map(function (_ref2) {
        var id = _ref2.id,
            description = _ref2.description,
            iconGrey = _ref2.iconGrey,
            iconActive = _ref2.iconActive;
        return React.createElement(TooltipOnHover, {
          key: id,
          id: id,
          placement: "top",
          tooltipContent: description
        }, React.createElement("div", {
          key: id,
          onClick: function onClick(event) {
            return _this3.onClickEmbeddableType(event, id);
          },
          className: "padding-vertical-normal embed-placeholder-icon-clickable margin-left-normal pointer shade-20 shade-05-on-hover"
        }, React.createElement(iconGrey, {
          className: 'embed-placeholder-icon-clickable-grey',
          size: 16
        }), React.createElement(iconActive, {
          className: 'embed-placeholder-icon-clickable-active',
          size: 16
        })));
      }));
    }
  }, {
    key: "renderCurrentEmbeddableType",
    value: function renderCurrentEmbeddableType(_ref3) {
      var id = _ref3.id,
          description = _ref3.description,
          iconActive = _ref3.iconActive;
      return React.createElement(TooltipOnHover, {
        id: id,
        placement: "top",
        tooltipContent: description
      }, React.createElement("div", null, React.createElement(iconActive, {
        size: 16,
        className: 'shade-20 margin-left-normal'
      })));
    }
  }, {
    key: "renderIcons",
    value: function renderIcons() {
      var embedType = this.props.embedType;
      var embeddableInformation = getEmbedInformation(embedType);

      if (embedType === EmbeddableTypes.DEFAULT) {
        return this.renderEmbeddablesTypes();
      }

      return this.renderCurrentEmbeddableType(embeddableInformation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          attributes = _this$props2.attributes,
          node = _this$props2.node,
          children = _this$props2.children,
          embedType = _this$props2.embedType,
          extractorsSelectorFilter = _this$props2.extractorsSelectorFilter;
      var hasText = node.text.length > 0;
      var embeddableInformation = getEmbedInformation(embedType);
      return React.createElement("form", Object.assign({}, attributes, {
        onSubmit: function onSubmit(event) {
          event.preventDefault();

          _this4.props.onSubmit(node.text, extractorsSelectorFilter);
        },
        "data-block-id": getBlockId(node),
        "data-text": embeddableInformation.placeholder,
        className: classNames(getBlockClassName(node), 'embed-placeholder', {
          'is-empty': !hasText,
          'padding-left-medium': hasText,
          'padding-right-normal': hasText,
          'padding-horizontal-medium': !hasText
        }, 'background-shade-50 shade-05 radius-normal', 'width-full position-relative overflow-hidden', 'margin-top-small padding-vertical-normal flexbox flexbox-align-center')
      }), React.createElement("section", {
        style: {
          flexGrow: 1
        },
        className: "ellipsis"
      }, children), React.createElement("section", {
        className: "flexbox flexbox-align-center padding-left-large",
        style: {
          right: 0,
          top: 0
        }
      }, hasText && React.createElement(Button.Primary, {
        onMouseDown: function onMouseDown(e) {
          e.stopPropagation();
          e.preventDefault();
        },
        className: "",
        type: "submit"
      }, "Embed"), !hasText && this.renderIcons()));
    }
  }]);

  return EmbedPlaceholder;
}(React.Component);

_defineProperty(EmbedPlaceholder, "propTypes", {
  node: PropTypes.object.isRequired,
  pluginStore: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  attributes: PropTypes.object.isRequired,
  editor: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  embedType: PropTypes.string.isRequired,
  extractorsSelectorFilter: PropTypes.func.isRequired
});

_defineProperty(EmbedPlaceholder, "defaultProps", {
  extractorsSelectorFilter: function extractorsSelectorFilter() {
    return true;
  }
});

export default EmbedPlaceholder;